module.exports = __webpack_public_path__ + "img/nzc.686f8cf5.png";